import React from "react";
import {Typography ,List} from 'antd';
const {Link, Text} = Typography;
const social = [
  { 
    icon: <img src="../../images/fb.png" alt=""/>,
    url : '#',
  },
  {
    icon: <img src="../../images/insta.png" alt=""/>,
    url : '#',
  },
  {
    icon: <img src="../../images/twitter.png" alt=""/>,
    url : '#',
  },
  {
    icon: <img src="../../images/happy.png" alt=""/>,
    url : '#',
  },  
];
const SocialMedia = ()=>{
    return (
      <div className="container">
        <div className="social">
        <List
            itemLayout="vertical"
            dataSource={social}
            renderItem={(item) => (
            <List.Item>
              <Link className="social-link" href={item.url}>{item.icon}</Link>
            </List.Item>
            )}
         />
       </div>
       <div className="copyright"  align="center">
        <Text>Copyright © vechain.energy All Rights reserved</Text>
       </div>
       </div>
    )
}
export default SocialMedia;